export const EMPTY_CATEGORY_NAME = 'Uncategorized';
